import * as navigation from 'Navigation';

class ProteinComplexPreviewTabState extends navigation.TabState {
  constructor({proteinIds}: {proteinIds: Array<string>}) {
    super();
    this.set('proteinIds', proteinIds);
  }

  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'AA Sequence Preview',
      closeable: true,
    };
  }
}

export {ProteinComplexPreviewTabState as tabState};
